import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import ErrorDialog from "../../components/Shared/ErrorDialog";

const ErrorContext = createContext(null);

export function useError() {
  return useContext(ErrorContext);
}

export const ErrorProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const showError = useCallback((err) => {
    if (!err) return;
    setError(err);
    setOpen(true);
  }, []);

  const hideError = useCallback(() => {
    setOpen(false);
    setError(null);
  }, []);

  useEffect(() => {
    const handler = (event) => {
      // Payload standardizzato: { error: {...} }
      const detail = event?.detail;
      const maybeError = detail?.error ?? detail ?? null;
      showError(maybeError);
    };

    if (typeof window !== "undefined") {
      window.addEventListener("wcp:error", handler);
      return () => window.removeEventListener("wcp:error", handler);
    }

    return undefined;
  }, [showError]);

  const value = useMemo(
    () => ({
      showError,
    }),
    [showError]
  );

  return (
    <ErrorContext.Provider value={value}>
      {children}
      <ErrorDialog open={open} onClose={hideError} error={error} />
    </ErrorContext.Provider>
  );
};

